<template>
  <v-app-bar color="white" elevation="0">
    <v-btn :href="frontendUrl">
      <v-app-bar-title><img :src="inletsLogo" alt="inlets.ai" class="brand-logo-img" /></v-app-bar-title>
    </v-btn>
  </v-app-bar>
  <v-app>
    <v-main>
      <v-container class="fill-height">
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" sm="8" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-left">
                <h3>Approve new user</h3>
              </v-card-title>
              <v-card-text>
                <v-row v-if="loading" align="center" justify="center" class="py-6">
                  <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                </v-row>
                <v-alert v-else-if="errorMessage" type="error" variant="tonal">
                  {{ errorMessage }}
                </v-alert>
                <template v-else-if="user">
                  <v-list density="compact" class="mb-4 pa-0">
                    <v-list-item title="Name" :subtitle="fullName"></v-list-item>
                    <v-list-item title="Email" :subtitle="user.email"></v-list-item>
                    <v-list-item
                      title="Email confirmed"
                      :subtitle="user.confirmed ? 'Yes' : 'Not yet. They can sign in once they confirm.'"
                    ></v-list-item>
                  </v-list>
                  <v-alert v-if="user.approved" type="success" variant="tonal">
                    {{ user.email }} is approved. We've emailed them to let them know.
                  </v-alert>
                  <v-btn v-else color="primary" :loading="approving" @click="approve">Approve</v-btn>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "@/axios.js";
import inletsLogo from "@/assets/images/inlets-logo-color.svg";

const BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "ApproveUser",
  data() {
    return {
      inletsLogo,
      loading: true,
      approving: false,
      user: null,
      errorMessage: null,
    };
  },
  computed: {
    frontendUrl() {
      return process.env.VUE_APP_FRONTEND_URL;
    },
    token() {
      return this.$route.query.token;
    },
    fullName() {
      return [this.user.first_name, this.user.last_name].filter(Boolean).join(" ");
    },
  },
  mounted() {
    if (this.token) {
      this.loadUser();
    } else {
      this.loading = false;
      this.errorMessage = "Missing approval link. Please use the link from the email.";
    }
  },
  methods: {
    async loadUser() {
      try {
        const response = await axios.get(`${BASE_URL}/user_approvals`, { params: { token: this.token } });
        this.user = response.data.user;
      } catch (error) {
        this.errorMessage = error.response?.data?.message || "Something went wrong. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    async approve() {
      this.approving = true;
      try {
        const response = await axios.post(`${BASE_URL}/user_approvals`, { token: this.token });
        this.user = response.data.user;
      } catch (error) {
        this.errorMessage = error.response?.data?.message || "Something went wrong. Please try again.";
      } finally {
        this.approving = false;
      }
    },
  },
};
</script>
